<template>
  <basic-container>
    <div class="path-container" style="margin-bottom: 20px; padding: 10px 15px; border-radius: 4px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>超级智能体工作站</el-breadcrumb-item>
        <el-breadcrumb-item>高血压智能体</el-breadcrumb-item>
        <el-breadcrumb-item>临床随访</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div style="margin-bottom: 1vh; padding: 0px 0px; border-radius: 4px">
      <el-breadcrumb separator="/">
        <!-- <el-breadcrumb-item :to="{ path: '/index' }">&lt;</el-breadcrumb-item> -->
        <i class="el-icon-back" style="font-size: 20px; font-weight: bolder" @click="back()"></i>
      </el-breadcrumb>
    </div>

    <el-button-group>
      <el-button class="healthButton" @click="click(0)">数字档案</el-button>
      <el-button class="healthButton" @click="click(2)">血压统计数据</el-button>
      <el-button class="healthButton" @click="click(3)">运动处方</el-button>
      <el-button class="healthButton" @click="click(1)">营养处方</el-button>
      <el-button class="healthButton" @click="click(4)">行为认知治疗</el-button>
      <el-button class="healthButton" @click="click(6)">药物方案</el-button>
      <el-button class="healthButton healthActive" @click="click(5)">运动随访</el-button>
    </el-button-group>
    <div class="card-row" style="margin-bottom: 20px">
      <div class="card card01">
        <div class="card-row" style="font-size: 20px; font-weight: bold; margin-bottom: 2vh">
          {{ info.name }}
        </div>
        <div class="card03" style="font-size: 14px">
          <div>性别：{{ info.sex === 1 ? '男' : info.sex === 2 ? '女' : '未填写' }}</div>
          <div>手机号码：{{ info.mobile }}</div>
        </div>
        <div class="card03" style="font-size: 14px">
          <div>年龄|生日：{{ info.age }}岁 / 未填写</div>
          <div>身高|体重：{{ info.height ? info.height : ' ' }}cm/{{ info.weight ? info.weight : ' ' }}kg</div>
          <div>身份证号：{{ info.idCard }}</div>
        </div>
      </div>
    </div>
    <div class="title">
      <div class="d1">
        {{ title }}
      </div>

      <div class="datePicker">
        随访时间:&nbsp;&nbsp;
        <el-date-picker v-model="clinicalFollow.followDate" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss" />
      </div>

      <div class="d2">
        <el-button @click="newFollow">新增运动随访</el-button>
        <el-button @click="open">查询记录</el-button>
        <el-button type="primary" @click="saveClinicalFollow">存档</el-button>
      </div>
    </div>

    <!-- <div class="myButton">
      <el-button @click="open">查询记录</el-button>
      <el-button type="primary" @click="saveClinicalFollow">存档</el-button>
    </div> -->

    <el-drawer title="查询记录" :visible.sync="drawer" :modal="false" :size="'300px'">
      <div style="display: flex" v-for="(item, index) in clinicalFollows" :key="index">
        <div class="clickDate" @click="clickDate(index)">{{ item.followDate }}{{ item.time ? ' - ' + item.time + '月' : '' }}</div>
        <div class="clickDateDelete" @click="clickDateDelete(item)">删除</div>
      </div>
    </el-drawer>

    <avue-form class="form" :option="option" ref="crud" :data="clinicalFollow" v-model="clinicalFollow" :page.sync="page">
      <template slot="menuLeft"></template>
    </avue-form>

    <div class="card-row">
      <div class="card card01">
        <div class="card-row tital01">
          <div>体重变化趋势图</div>
        </div>
        <div
          id="weightTrend"
          :style="{
            width: '100%',
            height: '30vh',
            minHeight: '270px',
            minWidth: '770px'
          }"
        ></div>
      </div>
    </div>
  </basic-container>
</template>

<script>
import { getMotion, getUserJkDetail, saveClinicalFollow, getClinicalFollow, deleteClinicalFollow, getWeightTrend } from '@/api/health/manage'
import func from '@/util/func'

export default {
  data() {
    return {
      wxUserId: this.$route.query.wxUserId,
      info: {},
      form: {},
      title: '新 增 运 动 随 访',
      clinicalFollow: {},
      clinicalFollows: [],
      drawer: false,
      hover: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      option: {
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: '基础疾病',
            prop: 'base',
            span: 6
          },
          {
            label: '病程',
            prop: 'course',
            span: 6
          },
          {
            label: '管理目标',
            prop: 'target',
            span: 6
          },
          {
            label: '干预时长(月)',
            prop: 'time',
            labelWidth: 100,
            span: 6
          },
          {
            label: '',
            prop: '',
            display: true,
            span: 24,
            detail: true,
            placeholder: ' '
          },
          {
            label: '',
            prop: '',
            display: true,
            span: 2,
            detail: true,
            placeholder: ' '
          },
          {
            label: '运动干预前体重(kg)',
            prop: 'beforeWeight',
            labelWidth: 141,
            append: 'kg',
            placeholder: ' ',
            span: 6
          },
          {
            label: '',
            prop: '',
            display: true,
            span: 4,
            detail: true,
            placeholder: ' '
          },
          {
            label: '运动干预后体重(kg)',
            prop: 'afterWeight',
            labelWidth: 141,
            append: 'kg',
            placeholder: ' ',
            span: 6
          },
          {
            label: '',
            prop: '',
            display: true,
            span: 6,
            detail: true,
            placeholder: ' '
          },
          {
            label: '',
            prop: '',
            display: true,
            span: 2,
            detail: true,
            placeholder: ' '
          },
          {
            label: '运动干预前舒张压(mmHg)',
            prop: 'beforeDia',
            labelWidth: 185,
            append: 'mmHg',
            placeholder: ' ',
            span: 6
          },
          {
            label: '',
            prop: '',
            display: true,
            span: 4,
            detail: true,
            placeholder: ' '
          },
          {
            label: '运动干预后舒张压(mmHg)',
            prop: 'afterDia',
            labelWidth: 185,
            append: 'mmHg',
            placeholder: ' ',
            span: 6
          },
          {
            label: '',
            prop: '',
            display: true,
            span: 6,
            detail: true,
            placeholder: ' '
          },
          {
            label: '',
            prop: '',
            display: true,
            span: 2,
            detail: true,
            placeholder: ' '
          },
          {
            label: '运动干预前收缩压(mmHg)',
            prop: 'beforeSys',
            labelWidth: 185,
            append: 'mmHg',
            placeholder: ' ',
            span: 6
          },
          {
            label: '',
            prop: '',
            display: true,
            span: 4,
            detail: true,
            placeholder: ' '
          },
          {
            label: '运动干预后收缩压(mmHg)',
            prop: 'afterSys',
            labelWidth: 185,
            append: 'mmHg',
            placeholder: ' ',
            span: 6
          },
          {
            label: '',
            prop: '',
            display: true,
            span: 6,
            detail: true,
            placeholder: ' '
          },
          {
            label: '',
            prop: '',
            display: true,
            span: 2,
            detail: true,
            placeholder: ' '
          },
          {
            label: '运动干预前空腹血糖(mmol/L)',
            prop: 'beforeKfBs',
            labelWidth: 205,
            append: 'mmol/L',
            placeholder: ' ',
            span: 6
          },
          {
            label: '',
            prop: '',
            display: true,
            span: 4,
            detail: true,
            placeholder: ' '
          },
          {
            label: '运动干预后空腹血糖(mmol/L)',
            prop: 'afterHba1c',
            labelWidth: 205,
            append: 'mmol/L',
            placeholder: ' ',
            span: 6
          },
          {
            label: '',
            prop: '',
            display: true,
            span: 6,
            detail: true,
            placeholder: ' '
          },
          {
            label: '',
            prop: '',
            display: true,
            span: 2,
            detail: true,
            placeholder: ' '
          },
          {
            label: '运动干预前糖化血红蛋白糖(%)',
            prop: 'beforeHba1c',
            labelWidth: 207,
            append: '%',
            placeholder: ' ',
            span: 6
          },
          {
            label: '',
            prop: '',
            display: true,
            span: 4,
            detail: true,
            placeholder: ' '
          },
          {
            label: '运动干预后糖化血红蛋白糖(%)',
            prop: 'afterBs',
            labelWidth: 207,
            append: '%',
            placeholder: ' ',
            span: 6
          },
          {
            label: '',
            prop: '',
            display: true,
            span: 6,
            detail: true,
            placeholder: ' '
          },
          {
            label: '',
            prop: '',
            display: true,
            span: 2,
            detail: true,
            placeholder: ' '
          },
          {
            label: '运动干预前体脂肪率(%)',
            prop: 'beforeFat',
            labelWidth: 165,
            append: '%',
            placeholder: ' ',
            span: 6
          },
          {
            label: '',
            prop: '',
            display: true,
            span: 4,
            detail: true,
            placeholder: ' '
          },
          {
            label: '运动干预后体脂肪率(%)',
            prop: 'afterFat',
            labelWidth: 165,
            append: '%',
            placeholder: ' ',
            span: 6
          }
        ]
      },
      data: [],
      showDialog: false // 控制弹框显示
    }
  },
  computed: {},
  created() {
    this.onLoad()
  },
  methods: {
    onLoad() {
      const wxUserId = this.$route.query.wxUserId

      getUserJkDetail(wxUserId).then(res => {
        const wxUserId = window.localStorage.getItem('pcUserId');
        if (wxUserId === '2043870969731301377') {
          res.data.userJk.name = func.maskName(res.data.userJk.name);
          res.data.userJk.mobile = func.maskPhone(res.data.userJk.mobile);
        }
        this.info = res.data.userJk
      })

      getMotion(wxUserId).then(res => {
        this.data = res.data
      })

      getClinicalFollow(wxUserId).then(res => {
        this.clinicalFollows = res.data
      })

      getWeightTrend(this.$route.query.wxUserId).then(res => {
        if (res.success) {
          this.healthBmi = res.data
          this.weightTrend()
        }
      })
    },

    weightTrend() {
      const healthBmi = this.healthBmi
      const date = []
      const weight = []
      let maxWeight = 0

      for (let i = 0; i < healthBmi.length; i++) {
        date.push(healthBmi[i].bmiDate)
        weight.push(healthBmi[i].weight)
        if (maxWeight < healthBmi[i].weight) maxWeight = healthBmi[i].weight
      }
      if (maxWeight === 0) maxWeight = 100

      const myChart = this.$echarts.init(document.getElementById('weightTrend'))
      // 绘制图表
      myChart.setOption({
        grid: {
          left: '2%',
          right: '2%',
          bottom: '1%',
          top: '15%',
          containLabel: true // 确保坐标轴标签显示在grid区域内
        },
        title: {
          // text: "",
          left: 'left',
          textStyle: {
            fontSize: 15
            // fontWeight: "bold",
          }
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            // 过滤掉值为null或undefined
            const validParams = params.filter(item => item.value !== null && item.value !== undefined)
            let result = ''
            if (validParams.length > 0) {
              result = validParams[0].axisValue + '<br/>'
              validParams.forEach(item => {
                result += `${item.marker}${item.seriesName}: ${item.value} kg`
              })
            }
            return result
          }
        },
        toolbox: {
          show: false,
          feature: {
            dataZoom: {
              yAxisIndex: 'none'
            },
            dataView: { readOnly: false },
            magicType: { type: ['line', 'bar'] },
            restore: {},
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: date,
          axisLabel: {
            interval: 'auto',
            rotate: date.length <= 8 ? 0 : 90,
            margin: 7
          },
          axisLine: {
            lineStyle: {
              // color: "#999",
            }
          },
          axisTick: {
            alignWithLabel: true
          }
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: maxWeight + 10,
          axisLabel: {
            formatter: '{value}'
          },
          axisLine: {
            show: false // 不显示轴线
          }
        },
        series: [
          {
            name: '体重',
            type: 'line',
            data: weight,
            stack: '总量',
            // areaStyle: {},
            symbol: weight.length === 1 ? '' : 'none',
            lineStyle: {
              color: 'green',
              width: 2,
              type: 'solid'
            }
          }
        ],
        color: ['green', 'red']
      })

      // 响应式调整
      window.addEventListener('resize', function () {
        myChart.resize()
      })
    },

    saveClinicalFollow() {
      this.clinicalFollow.wxUserId = this.wxUserId
      saveClinicalFollow(this.clinicalFollow).then(res => {
        if (res.success) {
          this.clinicalFollow.id = res.data.id
          this.title = res.data.followDate + ' 运动随访:'
          this.$message({
            message: '存档成功',
            type: 'success'
          })
        }
      })
    },

    newFollow() {
      this.clinicalFollow = {
        id: null,
        base: null,
        course: null,
        target: null,
        time: null,
        followDate: null,
        afterWeight: null,
        afterDia: null,
        afterSys: null,
        afterKfBs: null,
        afterHba1c: null,
        afterFat: null,
        beforeWeight: null,
        beforeDia: null,
        beforeSys: null,
        beforeKfBs: null,
        beforeHba1c: null,
        beforeFat: null
      }
      this.title = '新 增 运 动 随 访'
      console.log(this.clinicalFollow)
    },

    open() {
      this.drawer = true
      const wxUserId = this.$route.query.wxUserId
      getClinicalFollow(wxUserId).then(res => {
        this.clinicalFollows = res.data
      })
    },

    clickDate(index) {
      this.clinicalFollow = {
        id: null,
        base: null,
        course: null,
        target: null,
        time: null,
        followDate: null,
        afterWeight: null,
        afterDia: null,
        afterSys: null,
        afterKfBs: null,
        afterHba1c: null,
        afterFat: null,
        beforeWeight: null,
        beforeDia: null,
        beforeSys: null,
        beforeKfBs: null,
        beforeHba1c: null,
        beforeFat: null
      }

      setTimeout(res => {
        this.clinicalFollow = this.clinicalFollows[index]
        this.title = this.clinicalFollows[index].followDate + ' 运动随访:'
      }, 100)
    },

    clickDateDelete(item) {
      console.log(item.id)
      deleteClinicalFollow(item.id).then(res => {
        if (res.success) {
          this.getClinicalFollows()
        }
      })
    },

    getClinicalFollows() {
      getClinicalFollow(this.wxUserId).then(res => {
        this.clinicalFollows = res.data
      })
    },

    click(index) {
      let path = ''
      switch (index) {
        case 0:
          path = '/agent/blood/archive'
          break
        case 1:
          path = '/agent/blood/nutritionalPlan'
          break
        case 2:
          path = '/agent/blood/bodyComposition'
          break
        case 3:
          path = '/agent/blood/exercisePlan'
          break
        case 4:
          path = '/agent/blood/behavioralTherapy'
          break
        case 5:
          path = '/agent/blood/sportsFollow'
          break
        case 6:
          path = '/agent/blood/drugRegimen'
          break
      }
      const parameter = {
        wxUserId: this.wxUserId
      }
      this.$router.push({
        path: path,
        query: parameter
      })
    },

    back() {
      // this.$router.go(-1);
      this.$router.push({
        path: '/agent/blood/blood'
      })
    }
  }
}
</script>

<style scoped>
.my-dialog-class {
  display: flex;
  align-items: flex-start;
}

.prescription-container {
  font-family: 'SimSun', '宋体', serif;
  width: 210mm;
  padding: 10mm;
  box-sizing: border-box;
  float: left;
}

.pdf-options {
  padding-left: 2%;
  float: left;
  width: 100mm;
}

h1 {
  text-align: center;
  font-size: 24px;
  margin-bottom: 20px;
}

.info-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.info-table td {
  border: 1px solid #000;
  padding: 8px;
  font-size: 14px;
}

.section {
  margin-bottom: 15px;
}

h2,
h3 {
  font-size: 18px;
  margin: 10px 0;
  border-bottom: 1px solid #000;
  padding-bottom: 5px;
}

ul,
ol {
  margin-left: 20px;
}

.signature {
  text-align: right;
  margin-top: 40px;
}

.card-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1vh;
  gap: 10px;
}

.card {
  background: rgba(243, 235, 235, 0.884) 2F5;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 1vw;
  box-sizing: border-box;
}

.card01 {
  flex: 1;
  height: auto;
}

.card03 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin-bottom: 2vh;
}

.healthButton {
  /* background-color: #ebedf0; */
  color: black;
  border: 0px solid #c1c3c5;
  border-bottom: none;
  font-size: 15px;
  border-radius: 0px;
  margin-bottom: 2px;
}
.healthActive {
  border-bottom: 3px solid #409eff;
  color: #409eff;
  font-weight: bold;
}

.form {
  font-weight: bolder;
}

.myButton {
  text-align: right;
  margin-bottom: 15px;
  margin-right: 30px;
}

.title {
  position: relative;
  height: 80px;
}

.d1 {
  position: absolute;
  left: 20px;
  font-size: 20px;
  font-weight: bold;
}

.d2 {
  position: absolute;
  right: 20px;
}

.datePicker {
  position: absolute;
  top: 40px;
  left: 22px;
  font-size: 14px;
  font-weight: bold;
}

.clickDate {
  width: 70%;
  text-align: center;
  margin: 0px 0;
  padding: 10px 0;
  color: #2980b9;
  transform: skew(-15deg);
}

.clickDate:hover {
  text-decoration: underline;
  background-color: rgba(52, 152, 219, 0.1);
}

.clickDateDelete {
  width: 20%;
  text-align: center;
  margin: 0px 0;
  padding: 15px 0 0 0;
  color: #2980b9;
  font-size: 12px;
  transform: skew(-15deg);
}

.clickDateDelete:hover {
  text-decoration: underline;
  background-color: rgba(52, 152, 219, 0.1);
}
</style>
